import { defineMessage, IntlShape } from "react-intl";

import DateRangeType from "@mapmycustomers/shared/enum/DateRangeType";
import DateRange, {
  StandardCustomAndAllTimeRangeType,
} from "@mapmycustomers/shared/types/range/DateRange";

import { getOptionLabel as formatMonthRange } from "@app/component/input/dateRangeSelect/utils/useMonthOptions";
import { getOptionLabel as formatQuarterRange } from "@app/component/input/dateRangeSelect/utils/useQuarterOptions";
import { getOptionLabel as formatWeekRange } from "@app/component/input/dateRangeSelect/utils/useWeekOptions";
import parseRange from "@app/util/range/parseRange";
import formatDateRange from "@app/util/stackRank/formatDateRange";

const allTime = defineMessage({
  id: "dateRangeSelector.format.allTime",
  defaultMessage: "All-time",
  description: "Formatted text for the All time date range",
});

const formatDateTypeRange = (
  intl: IntlShape,
  dateRangeType: StandardCustomAndAllTimeRangeType | undefined,
  dateRange: DateRange | undefined,
  short?: boolean
) => {
  if (!dateRangeType || !dateRange || dateRangeType === DateRangeType.ALL) {
    return intl.formatMessage(allTime);
  }
  if (dateRangeType === DateRangeType.CUSTOM) {
    return formatDateRange(dateRange, short ? "PP" : "PPP");
  }
  const range = parseRange(dateRangeType);
  switch (range?.dateRangeType) {
    case DateRangeType.WEEK:
      return formatWeekRange(intl, dateRange, short);
    case DateRangeType.MONTH:
      return formatMonthRange(intl, dateRange, short);
    case DateRangeType.QUARTER:
      return formatQuarterRange(intl, dateRange, short);
  }
};

export default formatDateTypeRange;
